import React, { FC, useEffect, useMemo, useState } from 'react';

import NukaCarousel from '@r1-frontend/ui-react/components/NukaCarousel';
import { isClientSide } from '@r1-frontend/shared/helpers/ssr';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import type { ELocation } from '~/src/features/videocontrol/data';
import { dataMaxCountSlides, EMediaWidth } from '~/src/features/videocontrol/pageBlocks/StepsInstall/constants';

import { customDotsStyles } from '~/src/features/videocontrol/styled';
import * as ST from './styled';

interface TProps<T> {
    dataLength: number,
    Card: FC<{ product: T, activeTabLocation?: ELocation, domain?: string }>,
    data: T[],
    widthCard: number,
    activeTabLocation?: ELocation,
    domain?: string,
}

export const NukaWrapper = <T, >({ dataLength, data, Card, widthCard, activeTabLocation, domain }: TProps<T>): JSX.Element => {
    const isDesktop = useMatchMedia(EMediaWidth.desktop);
    const isSDesktop = useMatchMedia(EMediaWidth.sDesktop);
    const isLaptop = useMatchMedia(EMediaWidth.laptop);
    const isMobile = useMatchMedia(EMediaWidth.mobile);
    const [onClientSide, setOnClientSide] = useState(isClientSide());

    useEffect(() => {
        setOnClientSide(isClientSide);
    }, []);

    const countSlides = useMemo((): number => {
        switch (true) {
            case isDesktop:
                return dataMaxCountSlides.desktop;
            case isSDesktop:
                return dataMaxCountSlides.sDesktop;
            case isLaptop:
                return dataMaxCountSlides.laptop;
            case isMobile:
                return dataMaxCountSlides.mobile;
            default:
                return dataMaxCountSlides.mobile;
        }
    }, [isDesktop, isSDesktop, isLaptop, isMobile]);

    const cardsComponent = (data: any, dataTestType: string): JSX.Element => {
        return onClientSide && data.length && data.map((elem: any, key: number) => (
            <Card data-test={dataTestType} key={key} product={elem} activeTabLocation={activeTabLocation} domain={domain}/>
        ));
    };

    return (
        <ST.NukaContainer count={countSlides} widthCard={widthCard}>
            {dataLength > countSlides
                ? <>
                    <NukaCarousel data-test={'client-carousel'}
                        withoutArrows
                        wrapAround
                        slidesToShow={countSlides}
                        customDotsStyles={customDotsStyles}
                    >
                        {cardsComponent(data, 'card-1')}
                    </NukaCarousel>
                </>
                : cardsComponent(data, 'card-3')
            }
        </ST.NukaContainer>
    );
};
